<template>
    <div class="w-100 h-100 d-flex flex-column align-items-center">
        <!-- Search Data Conditional -->
        <template v-if="searchData !== null">
            <div
                class="section-title"
                v-if="searchData.search_result.length === 0"
            >
                <h6>
                    {{
                        `Foram encontrados os seguintes resultados para a pesquisa de ${searchdate}`
                    }}
                </h6>
            </div>

            <div class="section-title" v-else>
                <h2>
                    {{
                        `Não Foram encontrados resultados para a pesquisa de ${searchdate}`
                    }}
                </h2>
            </div>
        </template>

        <!-- Categories Filter -->
        <div class="filter-list-row categories-filter">
            <template v-if="customData.categories.length > 0">
                <ul
                    class="list-group list-group-horizontal selected-list list-item-offscreen-wraper"
                    data-indicate="categories"
                >
                    <li
                        v-for="(value, index) in customData.categories"
                        :key="value.id"
                        :data-refereindex="index"
                        :data-id="value.id"
                        :data-name="value.name"
                        data-indicate="categories"
                        @click="chooseItems($event, filterSelected.categories)"
                        class="list-group-item d-flex flex-row align-items-center justify-content-start"
                    >
                        <span
                            v-if="value.id !== 6"
                            class=""
                            data-indicate="categories"
                        >
                            <img
                                :src="`${categorypathimg}/${value.icon}.svg`"
                                :alt="value.name"
                                data-indicate="categories"
                            />
                        </span>
                        <p
                            :data-refereindex="index"
                            :data-id="value.id"
                            :data-name="value.name"
                            data-indicate="categories"
                            class=""
                        >
                            {{ value.name }}
                        </p>
                    </li>
                </ul>
            </template>
        </div>

        <!-- Base -->
        <div class="sidebar-content-wraper">
            <!-- Sidebar -->
            <aside class="sidebar-filter">
                <div class="filter-base d-flex flex-column">
                    <!-- All Filters -->
                    <div
                        class="row-all-filter-title"
                        role="button"
                        tabindex="0"
                        :aria-expanded="isOpen.toString()"
                        @click="toggleFilters"
                        @keydown.enter.prevent="toggleFilters"
                        @keydown.space.prevent="toggleFilters"
                    >
                        <div class="row-filter-structure">
                            <div class="filter-icon-and-title">
                                <span :class="{ rotated: isOpen }">
                                    <img
                                        :src="`${defaultpathimg}/chevronDown.svg`"
                                        alt="Filter Icon"
                                    />
                                </span>
                                <h6>Filtros ({{ filtertotal }})</h6>
                            </div>

                            <p
                                class="color-text-action"
                                role="button"
                                @click.stop="removeAllFilters()"
                            >
                                Remover filtros
                            </p>
                        </div>
                    </div>

                    <hr />

                    <div
                        id="filters-content"
                        ref="filtersWrapper"
                        class="row-filter-group-wrapper"
                        :aria-hidden="(!isOpen).toString()"
                    >
                        <!-- Locations -->
                        <div class="row-filter">
                            <div class="row-filter-structure">
                                <span
                                    role="button"
                                    class="deep-filter"
                                    @click="showFilterList($event)"
                                >
                                    <span class="filter-show-list">
                                        <img
                                            :src="`${defaultpathimg}/chevronDown.svg`"
                                            alt="Filter Icon"
                                        />
                                    </span>
                                    <p class="filter-type-title">
                                        Localização ({{
                                            filterSelected.locations.total
                                        }})
                                    </p>
                                </span>

                                <span
                                    role="button"
                                    class="deep-filter button-body color-text-action"
                                    data-indicate="locations"
                                    @click="
                                        cleanFilter($event, 'locations-list')
                                    "
                                    >Limpar</span
                                >
                            </div>

                            <div
                                class="d-flex flex-row flex-wrap filter-items-group-wraper"
                            >
                                <template
                                    v-if="customData.locations.length > 0"
                                >
                                    <ul
                                        class="list-group list-group-horizontal selected-list col-12 flex-wrap d-none locations-list"
                                        data-indicate="locations"
                                    >
                                        <li
                                            v-for="(
                                                value, index
                                            ) in customData.locations"
                                            :key="value.id"
                                            :data-refereindex="index"
                                            :data-id="value.id"
                                            :data-name="value.name"
                                            data-indicate="location"
                                            @click="
                                                chooseItems(
                                                    $event,
                                                    filterSelected.locations
                                                )
                                            "
                                            class="list-group-item filter-item d-flex flex-column align-items-center justify-content-center"
                                        >
                                            <span
                                                :data-refereindex="index"
                                                :data-id="value.id"
                                                :data-name="value.name"
                                                data-indicate="location"
                                                class="button-body"
                                                >{{ value.name }}</span
                                            >
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>

                        <!-- Available Time -->
                        <div class="row-filter">
                            <div class="row-filter-structure">
                                <span
                                    role="button"
                                    class="deep-filter"
                                    @click="showFilterList($event)"
                                >
                                    <span class="filter-show-list">
                                        <img
                                            :src="`${defaultpathimg}/chevronDown.svg`"
                                            alt="Filter Icon"
                                        />
                                    </span>
                                    <p class="filter-type-title">
                                        Disponibilidade ({{
                                            filterSelected.typeofreservation
                                                .total
                                        }})
                                    </p>
                                </span>
                                <span
                                    role="button"
                                    class="deep-filter button-body color-text-action"
                                    data-indicate="typeofreservation"
                                    @click="
                                        cleanFilter(
                                            $event,
                                            'typeofreservation-list'
                                        )
                                    "
                                    >Limpar</span
                                >
                            </div>

                            <div
                                class="d-flex flex-row flex-wrap filter-items-group-wraper"
                            >
                                <template
                                    v-if="
                                        customData.typeofreservation.length > 0
                                    "
                                >
                                    <ul
                                        class="list-group list-group-horizontal selected-list col-12 flex-wrap d-none typeofreservation-list"
                                        data-indicate="typeofreservation"
                                    >
                                        <li
                                            v-for="(
                                                value, index
                                            ) in customData.typeofreservation"
                                            :key="value.id"
                                            :data-refereindex="index"
                                            :data-id="value.id"
                                            data-indicate="typeofreservation"
                                            @click="
                                                chooseItems(
                                                    $event,
                                                    filterSelected.typeofreservation
                                                )
                                            "
                                            class="list-group-item filter-item d-flex flex-column align-items-center justify-content-center"
                                        >
                                            <span
                                                :data-refereindex="index"
                                                :data-id="value.id"
                                                data-indicate="typeofreservation"
                                                class="button-body"
                                                >{{ value.name }}</span
                                            >
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>

                        <!-- Accessries -->
                        <div class="row-filter">
                            <div class="row-filter-structure">
                                <span
                                    role="button"
                                    class="deep-filter"
                                    @click="showFilterList($event)"
                                >
                                    <span class="filter-show-list">
                                        <img
                                            :src="`${defaultpathimg}/chevronDown.svg`"
                                            alt="Filter Icon"
                                        />
                                    </span>
                                    <p class="filter-type-title">
                                        Acessórios ({{
                                            filterSelected.accessories.total
                                        }})
                                    </p>
                                </span>
                                <span
                                    role="button"
                                    class="deep-filter button-body color-text-action"
                                    data-indicate="accessories"
                                    @click="
                                        cleanFilter($event, 'accessories-list')
                                    "
                                    >Limpar</span
                                >
                            </div>

                            <div
                                class="d-flex flex-row flex-wrap filter-items-group-wraper"
                            >
                                <template
                                    v-if="customData.accessories.length > 0"
                                >
                                    <ul
                                        class="list-group list-group-horizontal selected-list col-12 flex-wrap d-none accessories-list"
                                        data-indicate="accessories"
                                    >
                                        <li
                                            v-for="(
                                                value, index
                                            ) in customData.accessories"
                                            :key="value.id"
                                            :data-refereindex="index"
                                            :data-id="value.id"
                                            data-indicate="accessories"
                                            @click="
                                                chooseItems(
                                                    $event,
                                                    filterSelected.accessories
                                                )
                                            "
                                            class="list-group-item filter-item d-flex flex-column align-items-center justify-content-center"
                                        >
                                            <span
                                                :data-refereindex="index"
                                                :data-id="value.id"
                                                data-indicate="accessories"
                                                class="button-body"
                                                >{{ value.name }}</span
                                            >
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>

                        <!-- Type of Location -->
                        <div class="row-filter">
                            <div class="row-filter-structure">
                                <span
                                    role="button"
                                    class="deep-filter"
                                    @click="showFilterList($event)"
                                >
                                    <span class="filter-show-list">
                                        <img
                                            :src="`${defaultpathimg}/chevronDown.svg`"
                                            alt="Filter Icon"
                                        />
                                    </span>
                                    <p class="filter-type-title">
                                        Tipo de Locação ({{
                                            filterSelected.typeoflocation.total
                                        }})
                                    </p>
                                </span>
                                <span
                                    role="button"
                                    class="deep-filter button-body color-text-action"
                                    data-indicate="typeoflocation"
                                    @click="
                                        cleanFilter(
                                            $event,
                                            'typeoflocation-list'
                                        )
                                    "
                                    >Limpar</span
                                >
                            </div>

                            <div
                                class="d-flex flex-row flex-wrap filter-items-group-wraper"
                            >
                                <template
                                    v-if="
                                        Object.values(customData.typeoflocation)
                                            .length > 0
                                    "
                                >
                                    <ul
                                        class="list-group list-group-horizontal selected-list col-12 flex-wrap d-none typeoflocation-list"
                                        data-indicate="typeoflocation"
                                    >
                                        <li
                                            v-for="(
                                                value, index
                                            ) in customData.typeoflocation"
                                            :key="value"
                                            :data-refereindex="index"
                                            :data-id="value"
                                            data-indicate="typeoflocation"
                                            @click="
                                                chooseItems(
                                                    $event,
                                                    filterSelected.typeoflocation
                                                )
                                            "
                                            class="list-group-item filter-item d-flex flex-column align-items-center justify-content-center"
                                        >
                                            <span
                                                :data-refereindex="index"
                                                :data-id="value"
                                                data-indicate="typeoflocation"
                                                class="button-body"
                                                >{{
                                                    value === 1
                                                        ? "Por Hora"
                                                        : "Por Período"
                                                }}</span
                                            >
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            <!-- Content -->
            <div class="content-filter">
                <div class="content-base">
                    <template v-if="Object.values(filterData).length > 0">
                        <div
                            v-for="(value, index) in filterData"
                            :key="value.id"
                            :data-refereindex="index"
                            :data-id="value.id"
                            :data-locationid="value.location_id"
                            class="d-flex flex-column card-plp"
                            aria-describedby="Choose the space"
                        >
                            <a
                                :href="`${baseurl}/location=${value.location_slug}&office=${value.slug}&route=${routine}`"
                                target="_self"
                                aria-describedby="Redirect to Space Page"
                            >
                                <figure>
                                    <div class="img-wrapper">
                                        <img
                                            :src="
                                                !value.media_data[0].thumbexist
                                                    ? value.media_data[0]
                                                          .media_original
                                                    : value.media_data[0]
                                                          .media_middle
                                            "
                                            :alt="
                                                value.media_data[0].data.filealt
                                            "
                                        />
                                        <template
                                            v-if="
                                                Object.hasOwn(
                                                    value,
                                                    'not_available'
                                                )
                                            "
                                        >
                                            <div
                                                v-if="value.not_available"
                                                class="not-available-info"
                                            >
                                                <div
                                                    class="not-available-header"
                                                >
                                                    <p
                                                        class="not-available-card-title strong-600"
                                                    >
                                                        Algumas datas
                                                        indisponíveis
                                                    </p>
                                                </div>
                                                <p>
                                                    Algumas das datas
                                                    selecionadas não estão
                                                    disponíveis
                                                </p>
                                            </div>
                                        </template>
                                    </div>

                                    <figcaption class="">
                                        <h6 class="filter-type-title">
                                            {{
                                                resumeMessage(value.name, 30, 2)
                                            }}
                                        </h6>
                                    </figcaption>
                                </figure>

                                <div class="card-info">
                                    <div>
                                        <div
                                            class="card-info-row card-location"
                                        >
                                            <img
                                                :src="`${defaultpathimg}/location.svg`"
                                                alt="Location Icon"
                                            />
                                            <p>
                                                {{
                                                    resumeMessage(
                                                        value.location_name,
                                                        30,
                                                        2
                                                    )
                                                }}
                                            </p>
                                        </div>

                                        <div
                                            class="card-info-row card-acessorie"
                                        >
                                            <div
                                                v-for="(
                                                    valaccessorie,
                                                    indexaccessorie
                                                ) in value.accessorie_id"
                                                :key="valaccessorie.id"
                                                :data-id="valaccessorie.id"
                                                :data-refereindex="
                                                    indexaccessorie
                                                "
                                                class="card-acessorie-item"
                                            >
                                                <img
                                                    :src="
                                                        valaccessorie.data[0]
                                                            .url
                                                    "
                                                    :alt="valaccessorie.name"
                                                />

                                                <p>
                                                    {{ valaccessorie.name }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-info-row card-info-cost">
                                        <p>
                                            <span
                                                class="color-text-action heading-6"
                                            >
                                                {{
                                                    value.rule.typeofreservation
                                                        .unique_reservation ===
                                                    1
                                                        ? value.value
                                                        : setCardPrice(value.value_number) 
                                                }}
                                            </span>
                                            {{
                                                value.rule.typeofreservation
                                                    .unique_reservation === 1
                                                    ? " /hora"
                                                    : setCardDescription()
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </template>

                    <template v-if="Object.values(filterData).length < 1">
                        <h4 class="no-data-found-message">
                            Nenhuma localização encontrada. <br />
                            Experimente alterar os filtros.
                        </h4>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import calendarRoutine from "./../../../calendarScript";

//Set Use Strict
("use strict");

export default {
    name: "Plp",
    props: {
        plpdata: {
            type: String,
            required: true,
        },
        customdata: {
            type: String,
            required: true,
        },
        baseurl: {
            type: String,
            required: true,
        },
        categorypathimg: {
            type: String,
            required: true,
        },
        defaultpathimg: {
            type: String,
            required: true,
        },
        searchdata: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            plpList: [],
            customData: [],
            filterSelected: {
                locations: {
                    data: [],
                    total: 0,
                },
                typeofreservation: {
                    data: [],
                    total: 0,
                },
                accessories: {
                    data: [],
                    total: 0,
                },
                categories: {
                    data: [],
                    total: 0,
                },
                typeoflocation: {
                    data: [],
                    total: 0,
                },
            },
            filtertotal: 0,
            filterData: {},
            searchData: null,
            searchdate: "",
            routine: "plp",
            isOpen: false,
        };
    },
    created() {
        //Decode data
        this.plpList = JSON.parse(this.plpdata);
        this.customData = JSON.parse(this.customdata);

        //Check seearchdata
        if (this.searchdata) {
            this.searchData =
                this.searchdata.length > 0 ? JSON.parse(this.searchdata) : null;
        }
    },
    mounted() {
        //Decode Data
        this.plpList.all.map((value) => (value.rule = JSON.parse(value.rule)));

        //Check Search Routine
        if (this.searchData === null) {
            //Get Data from Session Storage
            let searchdata = sessionStorage.getItem("search_data");

            //Get Path Info
            let path = window.location.pathname;

            //Check Search Data from sessionStorage
            if (searchdata && !path.includes("espacos")) {
                //Set Search Storage
                searchdata = JSON.parse(searchdata);

                //Set Search Data Callback Routine
                this.setCallbackForSearchData(searchdata);
            } else {
                //Set Data
                Object.assign(this.filterData, this.plpList.all);

                //Remove Item
                sessionStorage.removeItem("search_data");
            }
        } else {
            //Search Date
            this.setSearchDateStructure();

            //Check Search Result
            if (this.searchData.search_result.length === 0) {
                //Set New Routine when have data from Search Result
                this.routine = "search";

                //Set Search Data Callback Routine
                this.setCallbackForSearchData(this.searchData.search_data);
            } else {
                //Set New Routine when have data from Search Result
                this.routine = "search";

                //console.log('Set Search Result');
            }
        }

        const el = this.$refs.filtersWrapper;
        const isDesktop = window.innerWidth >= 1184;

        if (el && !isDesktop) {
            el.style.height = "0px";
            el.style.overflow = "hidden";
            el.style.transition = "height 250ms ease";
            el.addEventListener("transitionend", this.onTransitionEnd);
        } else if (isDesktop) {
            this.isOpen = true;
        }
    },
    beforeUnmount() {
        const el = this.$refs.filtersWrapper;
        if (el) el.removeEventListener("transitionend", this.onTransitionEnd);
    },
    methods: {
        setCardPrice(valueprice){

            let price = '';

            if(this.searchData === null){

                price = `${valueprice * this.customData.defaultvaluesforreservation.period_hour} €`;

                return price;

            }

            switch(this.searchData.search_data.turndata.data){

                case 3:
                    price = `${(valueprice * this.customData.defaultvaluesforreservation.period_hour) * 2} €`;
                break;

                default:
                    price = `${valueprice * this.customData.defaultvaluesforreservation.period_hour} €`;
                break;

            }

            return price;

        },
        setCardDescription(){

            let description = '';

            if(this.searchData === null){

                description = ` /período de ${this.customData.defaultvaluesforreservation.period_hour} horas`;

                return description;

            }

            switch(this.searchData.search_data.turndata.data){

                case 3:
                    description = ` /dia inteiro`;
                break;

                default:
                    description = ` /período de ${this.customData.defaultvaluesforreservation.period_hour} horas`;
                break;

            }

            return description;

        },
        resumeMessage(text, limit, divisor) {
            //console.log(text);
            if (text !== undefined) {
                let resume =
                    text.length > limit
                        ? `${text.substr(
                              0,
                              Math.round(text.length / divisor)
                          )}...`
                        : text;

                return resume;
            }
        },
        showFilterList(element) {
            //Element Button
            let elementBtn =
                element.target.nodeName === "SPAN"
                    ? element.target
                    : element.target.parentElement;

            //Check Element
            if (elementBtn.nodeName === "SPAN") {
                //Image
                let iconimg = elementBtn.classList.contains("filter-show-list")
                    ? elementBtn.firstElementChild
                    : elementBtn.firstElementChild.firstElementChild;

                //Chevron Icons
                let icondown = `${this.defaultpathimg}/chevronDown.svg`;
                let iconup = `${this.defaultpathimg}/chevronUp.svg`;

                //ElementList
                let elementList = elementBtn.classList.contains("deep-filter")
                    ? elementBtn.parentElement.nextElementSibling
                          .firstElementChild
                    : elementBtn.parentElement.parentElement.nextElementSibling
                          .firstElementChild;

                //Show List
                if (elementList.classList.contains("d-none")) {
                    //Add IconUp
                    iconimg.setAttribute("src", iconup);

                    elementList.classList.remove("d-none");
                } else {
                    //Add IconDown
                    iconimg.setAttribute("src", icondown);

                    elementList.classList.add("d-none");
                }
            }
        },
        chooseItems(element, selectedlist) {
            //Selected Element
            let selectedElement = "";

            //Selected Item
            let selectedItem = "";

            //Check Indicate
            switch (element.target.getAttribute("data-indicate")) {
                //typeofreservation, accessories
                case "typeofreservation":
                case "accessories":
                case "location":
                case "typeoflocation":
                    //Selected Element
                    selectedElement =
                        element.target.nodeName === "SPAN"
                            ? element.target.parentElement
                            : element.target;

                    //Get Id
                    selectedItem = parseInt(
                        element.target.getAttribute("data-id")
                    );

                    break;

                //categories
                case "categories":
                    switch (element.target.nodeName) {
                        case "LI":
                            //Selected Element
                            selectedElement = element.target;
                            //Get Id
                            selectedItem = parseInt(
                                element.target.getAttribute("data-id")
                            );
                            break;

                        case "P":
                            //Selected Element
                            selectedElement = element.target.parentElement;
                            //Get Id
                            selectedItem = parseInt(
                                element.target.getAttribute("data-id")
                            );
                            break;

                        case "SPAN":
                            //Selected Element
                            selectedElement =
                                element.target.parentElement.parentElement;
                            //Get Id
                            selectedItem = parseInt(
                                element.target.parentElement.getAttribute(
                                    "data-id"
                                )
                            );

                            break;

                        case "IMG":
                            //Selected Element
                            selectedElement =
                                element.target.parentElement.parentElement
                                    .parentElement;
                            //Get Id
                            selectedItem = parseInt(
                                element.target.parentElement.parentElement.getAttribute(
                                    "data-id"
                                )
                            );

                            break;
                    }

                    break;
            }

            //Push Selected Item
            if (selectedlist.data.length === 0) {
                selectedlist.data.push(selectedItem);

                //Add Selected Class
                selectedElement.classList.add("selected");
            } else {
                if (!selectedlist.data.includes(selectedItem)) {
                    selectedlist.data.push(selectedItem);

                    //Add Selected Class
                    selectedElement.classList.add("selected");
                } else {
                    //Get Index
                    let index = selectedlist.data.indexOf(selectedItem);

                    //Remove from List
                    selectedlist.data.splice(index, 1);

                    //Remove Selected Class
                    selectedElement.classList.remove("selected");
                }
            }

            //Set Total
            selectedlist.total = selectedlist.data.length;

            //Filter Routine
            this.filterRoutine(element.target.getAttribute("data-indicate"));
        },
        filterRoutine(indicate) {
            //Types of Filter
            let typesOfFilter = Object.keys(this.filterSelected);

            //Filter Conditional
            let filterConditional = [];

            typesOfFilter.forEach((value) => {
                //Check Selected Filter
                if (this.filterSelected[value].data.length > 0) {
                    //Set Filter Conditional
                    let filteritem = {
                        type: value,
                        data: this.filterSelected[value].data,
                    };

                    //Change datatype
                    filteritem.data.map((valitem) => valitem = parseInt(valitem));

                    filterConditional.push(filteritem);
                }
            });

            //Check FilterCondtional
            if (filterConditional.length > 0) {
                //Set Total from Selected Filter
                this.filtertotal =
                    indicate !== "categories"
                        ? filterConditional.length
                        : filterConditional.length - 1;

                //Filter Data
                let filterData = [];

                //console.log(filterConditional);

                //Find Location Filter Type
                let locationFilterExist = filterConditional.find(
                    (value) => value.type === "locations"
                );

                //Check when do not exist location filter
                if (locationFilterExist === undefined) {
                    //Filter Data
                    filterConditional.forEach((valfilter, index) => {
                        let i = 0;

                        switch (valfilter.type) {
                            case "categories":
                                do {
                                    filterData = this.plpList.all.filter(
                                        (value) =>
                                            value.categories_id_list.includes(
                                                valfilter.data[i]
                                            )
                                    );

                                    i++;
                                } while (i < valfilter.data.length);

                                i = 0;

                                break;

                            case "accessories":
                                do {
                                    filterData = this.plpList.all.filter(
                                        (value) =>
                                            value.accessorie_id_list.includes(
                                                valfilter.data[i]
                                            )
                                    );

                                    i++;
                                } while (i < valfilter.data.length);

                                i = 0;

                                break;

                            case "typeofreservation":
                                filterData = this.plpList.all.filter((value) =>
                                    valfilter.data.includes(
                                        value.rule.typeofreservation
                                            .periodic_reserve
                                    )
                                );

                                break;

                            case "typeoflocation":
                                filterData = this.plpList.all.filter((value) =>
                                    valfilter.data.includes(
                                        value.rule.typeofreservation
                                            .unique_reservation
                                    )
                                );

                                break;
                        }
                    });

                    //Set Filter Data
                    this.filterData = [...new Set(filterData)];

                    return;
                }

                //Location Index
                let locationIndex = 0;

                //Filter Data
                filterConditional.forEach((valfilter, index) => {
                    let i = 0;

                    switch (valfilter.type) {
                        case "locations":
                            locationIndex = index;

                            filterData = this.plpList.all.filter((value) =>
                                valfilter.data.includes(parseInt(value.location_id))
                            );

                            break;

                        case "categories":
                            do {
                                filterData = this.plpList.all.filter(
                                    (value) =>
                                        filterConditional[
                                            locationIndex
                                        ].data.includes(parseInt(value.location_id)) &&
                                        value.categories_id_list.includes(
                                            valfilter.data[i]
                                        )
                                );

                                i++;
                            } while (i < valfilter.data.length);

                            i = 0;

                            break;

                        case "accessories":
                            do {
                                filterData = this.plpList.all.filter(
                                    (value) =>
                                        filterConditional[
                                            locationIndex
                                        ].data.includes(parseInt(value.location_id)) &&
                                        value.accessorie_id_list.includes(
                                            valfilter.data[i]
                                        )
                                );

                                i++;
                            } while (i < valfilter.data.length);

                            i = 0;

                            break;

                        case "typeofreservation":
                            filterData = this.plpList.all.filter(
                                (value) =>
                                    filterConditional[
                                        locationIndex
                                    ].data.includes(parseInt(value.location_id)) &&
                                    valfilter.data.includes(
                                        value.rule.typeofreservation
                                            .periodic_reserve
                                    )
                            );

                            break;

                        case "typeoflocation":
                            filterData = this.plpList.all.filter(
                                (value) =>
                                    filterConditional[
                                        locationIndex
                                    ].data.includes(parseInt(value.location_id)) &&
                                    valfilter.data.includes(
                                        value.rule.typeofreservation
                                            .unique_reservation
                                    )
                            );

                            break;
                    }
                });

                //Set Filter Data
                this.filterData = [...new Set(filterData)];

                //console.log(filterData);

                return;
            }

            //Set Total from Selected Filter
            this.filtertotal = 0;

            //Set Data
            Object.assign(this.filterData, this.plpList.all);
        },
        setSearchDateStructure() {
            if (!Object.hasOwn(this.searchData, "search_data")) {
                return;
            }

            //Set Search date
            this.searchdate =
                this.searchData.search_data.filterbymonth.length > 0
                    ? calendarRoutine.searchContentMultipleMonths(
                          this.searchData.search_data.filterbymonth
                      )
                    : calendarRoutine.searchContent(
                          this.searchData.search_data.filter,
                          this.searchData.search_data.filter.month,
                          this.searchData.search_data.filter.year
                      );
        },
        cleanFilter(element, list) {
            //Check by Object Key
            if (
                Object.hasOwn(
                    this.filterSelected,
                    element.target.getAttribute("data-indicate")
                ) &&
                this.filterSelected[
                    element.target.getAttribute("data-indicate")
                ].data.length > 0
            ) {
                //Clean Data
                this.filterSelected[
                    element.target.getAttribute("data-indicate")
                ].data = [];
                this.filterSelected[
                    element.target.getAttribute("data-indicate")
                ].total = 0;

                //Remove selected class
                [...document.querySelector(`.${list}`).children].forEach(
                    (value) => value.classList.remove("selected")
                );

                //Hide Filter
                document.querySelector(`.${list}`).classList.add("d-none");

                //Return FilterData for your primary stage
                this.filterRoutine("default");
            }
        },
        removeAllFilters() {
            //Types of Filter
            let typesOfFilter = Object.keys(this.filterSelected);

            //All Selected List
            let allSelectedList = [
                ...document.querySelectorAll(".selected-list"),
            ];

            //Remove Filters from all selected list
            typesOfFilter.forEach((value) => {
                if (
                    value !== "categories" &&
                    this.filterSelected[value].data.length > 0
                ) {
                    //Clean
                    this.filterSelected[value].data = [];
                    this.filterSelected[value].total = 0;

                    //Get Selected
                    let list = allSelectedList.find(
                        (vallist) =>
                            vallist.getAttribute("data-indicate") === value
                    );

                    //Remove Selected Item
                    [...list.children].forEach((valitem) =>
                        valitem.classList.remove("selected")
                    );

                    //Hide Filter
                    list.classList.add("d-none");
                }
            });

            //Reset Filter Total
            this.filtertotal = 0;

            //Return FilterData for your primary stage
            this.filterRoutine("default");
        },
        setCallbackForSearchData(searchdata) {
            //Set Predefault Filter Conditional from search inputs
            this.filterSelected.locations.data.push(searchdata.city);
            this.filterSelected.locations.total =
                this.filterSelected.locations.data.length;

            this.filterSelected.typeoflocation.data.push(
                searchdata.typeoflocation
            );
            this.filterSelected.typeoflocation.total =
                this.filterSelected.typeoflocation.data.length;

            //Set Data
            Object.assign(this.filterData, this.plpList.all);

            //Filter Routine
            this.filterRoutine("locations");
            this.filterRoutine("typeoflocation");

            //Filter Routine from Search Data by Type of Location
            this.filterData = this.filterData.filter(
                (value) =>
                    parseInt(value.rule.typeofreservation.unique_reservation) ===
                    parseInt(searchdata.typeoflocation)
            );

            //Add Selected Class for Location
            this.addSelectedClass("locations-list", searchdata.city);
            this.addSelectedClass(
                "typeoflocation-list",
                searchdata.typeoflocation
            );
        },
        addSelectedClass(elementlist, valueindicate, attr = "data-id") {
            [...document.querySelector(`.${elementlist}`).children].forEach(
                (value) => {
                    if (parseInt(value.getAttribute(attr)) === valueindicate) {
                        value.classList.add("selected");
                    }
                }
            );
        },
        slugify(str) {
            if (!str) {
                return "";
            }
            return str
                .toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, "") // Remove caracteres especiais
                .replace(/[\s_-]+/g, "-") // Substitui espaços e hífens por hífens
                .replace(/^-+|-+$/g, ""); // Remove hífens no início e fim
        },
        toggleFilters() {
            if (window.innerWidth >= 1184) return;

            const el = this.$refs.filtersWrapper;
            if (!el) return;

            if (this.isOpen) {
                const current = el.scrollHeight;
                el.style.height = current + "px";
                void el.offsetHeight;
                el.style.height = "0px";
                this.isOpen = false;
            } else {
                el.style.height = "auto";
                this.isOpen = true;
            }
        },
        onTransitionEnd(e) {
            if (e.propertyName !== "height") return;

            const el = /** @type {HTMLElement} */ (this.$refs.filtersWrapper);
            if (!el) return;

            if (this.isOpen) {
                el.style.height = "auto";
            }
        },
    },
    computed: {
        computedFilterSelected() {
            return this.filterSelected;
        },
        computedFilterData() {
            return this.filterData;
        },
    },
    watch: {
        computedFilterSelected() {},
        computedFilterData() {},
    },
    destroyed() {
        //Clean Old Datas
        this.filterData = {};
        this.filterSelected = {
            locations: {
                data: [],
                total: 0,
            },
            typeofreservation: {
                data: [],
                total: 0,
            },
            accessories: {
                data: [],
                total: 0,
            },
            categories: {
                data: [],
                total: 0,
            },
            typeoflocation: {
                data: [],
                total: 0,
            },
        };
        this.searchData = null;
    },
};
</script>
